import React, { useEffect, useRef, useState } from "react";
import "../App.css";

function HomePage(props) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const imagesContainerRef = useRef(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isScrolling, setIsScrolling] = useState(false);
  const [scrollDirection, setScrollDirection] = useState(null);

  useEffect(() => {
    if (imagesContainerRef.current) {
      imagesContainerRef.current.scrollLeft = 0;
    }

    async function fetchImages() {
      try {
        const response = await fetch(`${API_BASE_URL}/get-all`);
        if (!response.ok) {
          throw new Error("Failed to fetch images");
        }
        const data = await response.json();
        console.log("Fetched images:", data);

        // Filter images to only include those matching props.showSection
        const filteredImages = data.filter(
          (item) => item.metadata[props.showSection] === "true"
        );

        // Sort filtered images by the number after the underscore in item.name
        const sortedImages = filteredImages.sort((a, b) => {
          const numberA = parseInt(a.name.split("_")[1], 10);
          const numberB = parseInt(b.name.split("_")[1], 10);
          return numberA - numberB;
        });

        console.log(sortedImages);
        setImages(sortedImages);
      } catch (error) {
        console.error("Error fetching images:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchImages();
  }, [API_BASE_URL, props.showSection]);
  useEffect(() => {
    let scrollInterval;
    if (isScrolling && imagesContainerRef.current) {
      scrollInterval = setInterval(() => {
        if (scrollDirection === "left") {
          imagesContainerRef.current.scrollLeft -= 10;
        } else if (scrollDirection === "right") {
          imagesContainerRef.current.scrollLeft += 10;
        }
      }, 16); // Approximately 60fps
    }
    return () => clearInterval(scrollInterval);
  }, [isScrolling, scrollDirection]);

  const handleMouseEnter = (direction) => {
    setIsScrolling(true);
    setScrollDirection(direction);
  };

  const handleMouseLeave = () => {
    setIsScrolling(false);
    setScrollDirection(null);
  };
  if (loading) {
    return <div className="loading">Loading images...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="HomePage my-0 my-md-5">
      <div className="images" ref={imagesContainerRef}>
        {images.length > 0 ? (
          images.map((image, index) => (
            <img
              key={index}
              src={image.images[0]}
              alt={`${image.name} ${index + 1}`}
              className="image"
            />
          ))
        ) : (
          <div className="no-images">No images to display</div>
        )}
        <button
          className="scroll-button-left "
          onMouseEnter={() => handleMouseEnter("left")}
          onMouseLeave={handleMouseLeave}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            fill="white"
            width={20}
          >
            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
          </svg>
        </button>
        <button
          className="scroll-button-right"
          onMouseEnter={() => handleMouseEnter("right")}
          onMouseLeave={handleMouseLeave}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            fill="white"
            width={20}
          >
            <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default HomePage;
